import '../App.css';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import getEntities from '../services/entities';
import Row from './Row';

export default function Table({ data }) {
    const[contents, setContents] = useState([])

    useEffect(function() {
        console.log('Dibujar tabla');
        getEntities('/estatutos/regulaciones', data).then(async(cntnts) => {
            console.log(cntnts)
            const formattedContents = await buildRowsArray(cntnts, 1);
            console.log(formattedContents)
            setContents(formattedContents)
        })
    }, [data])

    const buildRowsArray = async (arr, index) => {
        let rows = [];
        let firstElem = true;
        for(const elem of arr){
            const { items, ...data } = elem;
            rows.push({ depth: index, key: `TabRow${ index }-${ elem.id }`, firstElem, ...data });
            firstElem = false;
            if(items?.length > 0){
                rows = rows.concat(await buildRowsArray(items, index + 1));
            }
        }
        return rows;
    };

    return (
        <table>
            <tbody>
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th className='text-small title-cell' style={{ minWidth: '60px'}}>Etapa</th>
                    <th></th>
                    <th className='text-small content-cell'>Contenido</th>
                </tr>
                {
                    contents.map(row => 
                        <Row
                            id = { row.id }
                            title = { row.titulo }
                            clave = { row.clave }
                            depth = { row.depth }
                            description = { row.descripcion }
                            context = { row.idcontexto }
                            key = { row.key }
                            firstElem = { row.firstElem }
                        />
                    )
                }
            </tbody>
        </table>
    )
}

Table.propTypes = {
    data: PropTypes.object
};
